<template>
   <div class="card mb-2 shadow-sm" style="background-color: rgb(238, 238, 238);">
      <!-- portada -->
      <div v-if="content.resumeContentResponse.frontPageColor" 
         class="card-header hgh-header"
         :style="{'background-color': content.resumeContentResponse.frontPageColor.background}"      >
      </div>
      <!-- {{content.resumeContentResponse.rectangleCard}} -->
      <div class="card-body py-1 rsm-card rounded" 
         @click="viewModal(content.resumeContentResponse.id)"
         :class="content.resumeContentResponse.copyAlert ? 'bg-warning' : ''"
         >
         <!-- tableros -->
         <div v-if="content.resumeContentResponse.boardsContent"
            class="row row-cols-auto d-flex justify-content-start"
            >
            <board-rectangle 
               v-for="(board, index) in content.resumeContentResponse.boardsContent" :key="index"
               :board="board"
               small
               class="ms-1 pb-1"
               />
         </div>
         <!-- etiquetas -->
         <div v-if="content.resumeContentResponse.labelsContent.length>0"
            class="row row-cols-auto d-flex justify-content-start"
         >
            <div v-for="(label, index) in content.resumeContentResponse.labelsContent" 
                  :key="index" 
                  class="col p-0 pb-1 ms-1"
                  >
               <div class="bg-lb-resume px-2 rounded-pill" 
                     :style="{'background-color': label.backGroundColor}"
                     :title="label.name + ' (' + label.id + ')'"
                     >
                     <!--
         :style="{'background-color': circleUser.bg_color , 'color': circleUser.text_color}" 
                     <div class="bg-lb-resume-into mt-1 rounded-pill">
                     </div>   border rounded shadow-sm
                     <div class="bg-lb-resume-into rounded-pill"
                        :style="{'background-color': label.textColor}"
                           >
                     </div>
                     -->
                     <div v-if=" label.position == 'R' " class="bg-lb-resume-right rounded-pill"
                        :style="{'background-color': label.textColor}">
                     </div>
                     <div v-if=" label.position == 'C' " class="bg-lb-resume-center rounded-pill"
                        :style="{'background-color': label.textColor}">
                     </div>
                     <div v-if=" label.position == 'L' " class="bg-lb-resume-left rounded-pill"
                        :style="{'background-color': label.textColor}">
                     </div>
               </div>
            </div>
         </div>
         <!-- 
            :class=" cancelled ? 'bg-danger px-1 rounded text-light' : '' " 
            <div class="col-12 bkgc-v ps-1 text-break tc-d-gray fs-13 border rounded shadow-sm">
               <b>{{content.resumeContentResponse.title}}</b>
                     <h6 class="text-break"><b><div v-html="content.title"></div></b></h6>
        -->
         <!-- titulo -->
         <div class="row" >
            <div class="col-12 bkgc-v ps-1 text-break tc-d-gray fs-13 border rounded shadow-sm"
                  :class=" content.resumeContentResponse.cancelled ? 'bg-danger text-light' : '' " 
                  >
               <b><div v-html="htmlTitle"></div></b>
            </div>
         </div>
         <div class="row row-cols-auto d-flex justify-content-start fs-12 pt-1">
            <!-- fechas -->
            <div v-if="content.resumeContentResponse.enableDates"
               class="rounded p-1 me-1"
               :style="{'background-color': dateBgColor()}"
            >
               <font-awesome-icon icon="clock" />&nbsp;
               <b>{{dateFormat(content.resumeContentResponse.startDate)}} al {{dateFormat(content.resumeContentResponse.endDate)}}</b>
            </div>
            <!-- descripcion -->
            <div v-if="content.resumeContentResponse.anyDescription"
               class="tc-d-gray p-1 px-2"
            >
               <font-awesome-icon icon="align-justify" />
            </div>
            <!-- comentarios -->
            <div v-if="content.resumeContentResponse.totalComments > 0" 
               class="tc-d-gray p-1 px-2"
            >
               <font-awesome-icon icon="comment" />&nbsp;
               <b>{{content.resumeContentResponse.totalComments}}</b>
            </div>
            <!-- adjuntos -->
            <div v-if="content.resumeContentResponse.totalAttachs > 0" 
               class="tc-d-gray p-1 px-2"
            >
               <font-awesome-icon icon="paperclip" />&nbsp;
               <b>{{content.resumeContentResponse.totalAttachs}}</b>
            </div>
            <!-- check list -->
            <div v-if="content.resumeContentResponse.totalControls > 0" 
               class="tc-d-gray p-1 px-2"
            >
               <font-awesome-icon icon="check-square" />&nbsp;
               <b>{{content.resumeContentResponse.totalChecked}}/{{content.resumeContentResponse.totalControls}}</b>
            </div>
         </div>
         <!-- llamada al modal del contenido -->
         <button v-show="false" 
            type="button" class="btn btn-sm btn-card"  
            data-bs-toggle="modal" data-bs-target="#mdContent" 
            :data-cntt-id="content.resumeContentResponse.id" 
            :data-cell-id="cell_id"
            :data-cellContent-id="content.cellContentId"
            ref="btnEdit"
         >
         </button>
         <div class="row pt-1">
            <!-- tarjeta -->
            <div class="col-1 p-0" >
               <CardRectangle :rectangleCard="content.resumeContentResponse.rectangleCard" class="mt-1"/>
            </div>
            <!-- usuarios -->
               <div class="col-11 d-flex justify-content-end flex-wrap p-0">
                  <UserCircle 
                     v-for="(circleUser, index) in content.resumeContentResponse.usersContent" 
                     :key="index"
                     :circleUser="circleUser"
                     class="ms-1 mt-1"
                     />
               </div>
         </div>
         <!--
         -->
      </div>
   </div>
</template>

<script>
import moment from 'moment';

import WspService from '../workSpace.service';

import UserCircle from '/src/components/UserCircle.vue';
import CardRectangle from "./CardRectangle.vue";
import BoardRectangle from "./BoardRectangle.vue";

export default {
   components: {
      UserCircle,
      CardRectangle,
      BoardRectangle
   },
   props: {
      content: {
         type: Object
      },
      cell_id: {
         type: Number
      },
   },
   computed: {
      htmlTitle() {
         return WspService.htmlSeparator( this.content.resumeContentResponse.title );
      }
   },
   /*   const htmlTitle = computed(() => {
         return WspService.htmlSeparator( props.title );
      }),*/
   methods: {
      viewModal(contentId) {
         this.$refs.btnEdit.click();
         console.log("view modal contentId: "+contentId);
      },
      dateFormat(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY');
      },
      dateBgColor() {
         this.btnDatesColor = "#D0D3D4"
         
         if (this.content.resumeContentResponse.okDate) {
            this.btnDatesColor = "#9CCC65"
         } else {
            this.btnDatesColor = "#D0D3D4"
            let today = new Date()
               today.setHours(0,0,0,0)
            let endDt = new Date(this.content.resumeContentResponse.endDate)
               endDt.setHours(0,0,0,0)
            if (today.getTime() == endDt.getTime())
               this.btnDatesColor = "#FDD835"
            if (today.getTime() > endDt.getTime())
               this.btnDatesColor = "#FF9E80"
         }
         
         return this.btnDatesColor;
      }
   },
};
</script>

<style scoped>
.bkgc-g {
   width: 30px;
   height: 30px;
   font-size: 13px;
}
.fix-edit-bg {
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background-color: gray;
   opacity: .1;
}
.fix-edit-icon {
   position: absolute;
   top: 0px;
   right: 5px;
   color: white;
   font-size: 18px;
}
.hgh-header {
   height: 30px;
}
.bg-lb-resume {
   width: 40px;
   height: 9px;
}
.bg-lb-resume-left {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   right: 7px;
/*   left: 16px;
   left: 5px;
   right: 7px;*/
}
.bg-lb-resume-center {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   left: 5px
/*   left: 16px;
   left: 5px;
   right: 7px;*/
}
.bg-lb-resume-right {
   width: 14px;
   height: 7px;
   position: relative;
   top: 1px;
   left: 16px
/*   left: 16px;
   left: 5px;
   right: 7px;*/
}
/*
.bg-lb-resume {
   width: 40px;
   height: 12px;
}
.bg-lb-resume-into {
   width: 22px;
   height: 4px;
   position: relative;
   top: 4px;
   left: 1px;
}
*/
.tc-gray {
   color: gray;
}
.tc-d-gray {
   color: darkslategray;
}
.fs-11 {
   font-size: 11px;
}
.fs-12 {
   font-size: 12px;
}
.fs-13 {
   font-size: 13px;
}
.fs-14 {
   font-size: 14px;
}
.rsm-card {
   background-color: rgb(238, 238, 238);
}
.rsm-card:hover {
   background-image: url('/edit-regular.svg');
   background-repeat: no-repeat;
   background-size: 190% 18px;
   background-color: rgb(224, 224, 224);
   cursor: pointer;
}

</style>